import {
  GET_ORGANIZATIONS,
  GET_ORGANIZATION,
  CREATE_ORGANIZATION,
  UPDATE_ORGANIZATION,
  DELETE_ORGANIZATION,
  TOGGLE_DISABLE_ORGANIZATION,
  CREATE_OR_UPDATE_STORE,
  GET_PERMISSIONS,
  CREATE_OR_UPDATE_PERMISSION,
  GET_ROLES,
  CREATE_OR_UPDATE_ROLE,
  CREATE_OR_UPDATE_BRAND,
  CREATE_OR_UPDATE_COUNTRY,
} from '../gql/organization';
import { ApolloClientPromoService } from '../services/ApolloClientPromoService';

// Action Types
export const FETCH_ORGANIZATIONS = 'FETCH_ORGANIZATIONS';
export const FETCH_ORGANIZATION = 'FETCH_ORGANIZATION';
export const CREATE_ORGANIZATION_ACTION = 'CREATE_ORGANIZATION_ACTION';
export const UPDATE_ORGANIZATION_ACTION = 'UPDATE_ORGANIZATION_ACTION';
export const DELETE_ORGANIZATION_ACTION = 'DELETE_ORGANIZATION_ACTION';
export const TOGGLE_DISABLE_ORGANIZATION_ACTION =
  'TOGGLE_DISABLE_ORGANIZATION_ACTION';

// Action Creators
export const fetchOrganizations = (input) => async (dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_ORGANIZATIONS,
      variables: { input },
    });
    dispatch({ type: FETCH_ORGANIZATIONS, payload: data.organizations });
  } catch (error) {
    console.error('Error fetching organizations:', error);
  }
};

export const fetchOrganization = (id) => async (dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_ORGANIZATION,
      variables: { id },
    });
    dispatch({ type: FETCH_ORGANIZATION, payload: data.organization });
  } catch (error) {
    console.error('Error fetching organization:', error);
  }
};

export const createOrganization = (input) => async (dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_ORGANIZATION,
      variables: input,
    });
    dispatch({
      type: CREATE_ORGANIZATION_ACTION,
      payload: data.createOrganization,
    });
  } catch (error) {
    console.error('Error creating organization:', error);
  }
};

export const updateOrganization = (input) => async (dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: UPDATE_ORGANIZATION,
      variables: { input },
    });
    dispatch({
      type: UPDATE_ORGANIZATION_ACTION,
      payload: data.updateOrganization,
    });
  } catch (error) {
    console.error('Error updating organization:', error);
  }
};

export const deleteOrganization = (id) => async (dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: DELETE_ORGANIZATION,
      variables: { id },
    });
    dispatch({
      type: DELETE_ORGANIZATION_ACTION,
      payload: data.deleteOrganization,
    });
  } catch (error) {
    console.error('Error deleting organization:', error);
  }
};

export const toggleDisableOrganization = (input) => async (dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: TOGGLE_DISABLE_ORGANIZATION,
      variables: { input },
    });
    dispatch({
      type: TOGGLE_DISABLE_ORGANIZATION_ACTION,
      payload: data.toggleDisableOrganization,
    });
  } catch (error) {
    console.error('Error toggling organization status:', error);
  }
};

export const getPermissions = async (dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_PERMISSIONS,
    });
    if (dispatch) {
      dispatch({ type: 'FETCH_PERMISSIONS', payload: data.permissions });
    }
    return data?.permissions;
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

export const createOrUpdatePermissions = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_OR_UPDATE_PERMISSION,
      variables: input,
    });
    if (dispatch) {
      dispatch({
        type: 'CREATE_OR_UPDATE_PERMISSION_ACTION',
        payload: data.createOrUpdatePermission,
      });
    }
    return data?.createOrUpdatePermission;
  } catch (error) {
    console.error('Error creating or updating permissions:', error);
  }
};

export const getRoles = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_ROLES,
      variables: input,
    });
    if (dispatch) {
      dispatch({ type: 'FETCH_ROLES', payload: data.roles });
    }
    return data?.roles;
  } catch (error) {
    console.error('Error fetching roles:', error);
  }
};

export const createOrUpdateRole = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_OR_UPDATE_ROLE,
      variables: input,
    });
    if (dispatch) {
      dispatch({
        type: 'CREATE_OR_UPDATE_ROLE_ACTION',
        payload: data.createOrUpdateRole,
      });
    }
    return data?.createOrUpdateRole;
  } catch (error) {
    console.error('Error creating or updating role:', error);
  }
};

export const createOrUpdateBrand = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_OR_UPDATE_BRAND,
      variables: input,
    });
    dispatch({
      type: 'CREATE_OR_UPDATE_BRAND_ACTION',
      payload: data.createOrUpdateBrand,
    });

    return data.createOrUpdateBrand;
  } catch (error) {
    console.error('Error creating or updating brand:', error);
  }
};

export const createOrUpdateCountry = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_OR_UPDATE_COUNTRY,
      variables: input,
    });
    dispatch({
      type: 'CREATE_OR_UPDATE_COUNTRY_ACTION',
      payload: data.createOrUpdateCountry,
    });

    return data?.createOrUpdateCountry;
  } catch (error) {
    console.error('Error creating or updating country:', error);
  }
};

export const createOrUpdateStore = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_OR_UPDATE_STORE,
      variables: input,
    });
    if (dispatch) {
      dispatch({
        type: 'CREATE_OR_UPDATE_STORE_ACTION',
        payload: data.createOrUpdateStore,
      });
    }
    return data?.createOrUpdateStore;
  } catch (error) {
    console.error('Error creating or updating store:', error);
  }
};
